var _defs, _circle, _circle2, _circle3, _line, _line2, _text, _text2, _line3, _line4, _text3, _text4, _line5, _line6, _text5, _text6, _line7, _line8, _text7, _text8, _line9, _line10, _text9, _text10, _line11, _line12, _text11, _text12, _line13, _line14, _text13, _text14, _line15, _line16, _text15, _text16, _line17, _line18, _text17, _text18, _line19, _line20, _text19, _text20, _line21, _line22, _text21, _text22, _line23, _line24, _text23, _text24, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBirthWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b1a3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26235a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: "35%",
    cy: "35%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9a6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b8392a"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 196,
    fill: "url(#g)",
    stroke: "#5a55b8",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 152,
    fill: "#12122a",
    stroke: "#4a4699",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 96,
    stroke: "#3b3880",
    strokeWidth: 1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 352,
    y1: 200,
    x2: 396,
    y2: 200,
    stroke: "#4a4699",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 296,
    y1: 200,
    x2: 352,
    y2: 200,
    stroke: "#2f2d6a",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 368.1,
    y: 250,
    textAnchor: "middle",
    fontSize: 15,
    fill: "#b9b6f0"
  }, "\u2648&#xFE0E;")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 319.8,
    y: 236.1,
    textAnchor: "middle",
    fontSize: 11,
    fontFamily: "Roboto, sans-serif",
    fill: "#6f6cb0"
  }, "1")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 331.6,
    y1: 276,
    x2: 369.7,
    y2: 298,
    stroke: "#4a4699",
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 283.1,
    y1: 248,
    x2: 331.6,
    y2: 276,
    stroke: "#2f2d6a",
    strokeWidth: 1
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 323,
    y: 328,
    textAnchor: "middle",
    fontSize: 15,
    fill: "#b9b6f0"
  }, "\u2649&#xFE0E;")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 287.7,
    y: 291.7,
    textAnchor: "middle",
    fontSize: 11,
    fontFamily: "Roboto, sans-serif",
    fill: "#6f6cb0"
  }, "2")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 276,
    y1: 331.6,
    x2: 298,
    y2: 369.7,
    stroke: "#4a4699",
    strokeWidth: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 248,
    y1: 283.1,
    x2: 276,
    y2: 331.6,
    stroke: "#2f2d6a",
    strokeWidth: 1
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 373.1,
    textAnchor: "middle",
    fontSize: 15,
    fill: "#b9b6f0"
  }, "\u264A&#xFE0E;")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 232.1,
    y: 323.8,
    textAnchor: "middle",
    fontSize: 11,
    fontFamily: "Roboto, sans-serif",
    fill: "#6f6cb0"
  }, "3")), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 352,
    x2: 200,
    y2: 396,
    stroke: "#4a4699",
    strokeWidth: 1.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 296,
    x2: 200,
    y2: 352,
    stroke: "#2f2d6a",
    strokeWidth: 1
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 373.1,
    textAnchor: "middle",
    fontSize: 15,
    fill: "#b9b6f0"
  }, "\u264B&#xFE0E;")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 167.9,
    y: 323.8,
    textAnchor: "middle",
    fontSize: 11,
    fontFamily: "Roboto, sans-serif",
    fill: "#6f6cb0"
  }, "4")), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 124,
    y1: 331.6,
    x2: 102,
    y2: 369.7,
    stroke: "#4a4699",
    strokeWidth: 1.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 152,
    y1: 283.1,
    x2: 124,
    y2: 331.6,
    stroke: "#2f2d6a",
    strokeWidth: 1
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 77,
    y: 328,
    textAnchor: "middle",
    fontSize: 15,
    fill: "#b9b6f0"
  }, "\u264C&#xFE0E;")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 112.3,
    y: 291.7,
    textAnchor: "middle",
    fontSize: 11,
    fontFamily: "Roboto, sans-serif",
    fill: "#6f6cb0"
  }, "5")), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 68.4,
    y1: 276,
    x2: 30.3,
    y2: 298,
    stroke: "#4a4699",
    strokeWidth: 1.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 116.9,
    y1: 248,
    x2: 68.4,
    y2: 276,
    stroke: "#2f2d6a",
    strokeWidth: 1
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 31.9,
    y: 250,
    textAnchor: "middle",
    fontSize: 15,
    fill: "#b9b6f0"
  }, "\u264D&#xFE0E;")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 80.2,
    y: 236.1,
    textAnchor: "middle",
    fontSize: 11,
    fontFamily: "Roboto, sans-serif",
    fill: "#6f6cb0"
  }, "6")), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 200,
    x2: 4,
    y2: 200,
    stroke: "#4a4699",
    strokeWidth: 1.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 200,
    x2: 48,
    y2: 200,
    stroke: "#2f2d6a",
    strokeWidth: 1
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 31.9,
    y: 160,
    textAnchor: "middle",
    fontSize: 15,
    fill: "#b9b6f0"
  }, "\u264E&#xFE0E;")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 80.2,
    y: 171.9,
    textAnchor: "middle",
    fontSize: 11,
    fontFamily: "Roboto, sans-serif",
    fill: "#6f6cb0"
  }, "7")), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 68.4,
    y1: 124,
    x2: 30.3,
    y2: 102,
    stroke: "#4a4699",
    strokeWidth: 1.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 116.9,
    y1: 152,
    x2: 68.4,
    y2: 124,
    stroke: "#2f2d6a",
    strokeWidth: 1
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 77,
    y: 82,
    textAnchor: "middle",
    fontSize: 15,
    fill: "#b9b6f0"
  }, "\u264F&#xFE0E;")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 112.3,
    y: 116.3,
    textAnchor: "middle",
    fontSize: 11,
    fontFamily: "Roboto, sans-serif",
    fill: "#6f6cb0"
  }, "8")), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 124,
    y1: 68.4,
    x2: 102,
    y2: 30.3,
    stroke: "#4a4699",
    strokeWidth: 1.5
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 152,
    y1: 116.9,
    x2: 124,
    y2: 68.4,
    stroke: "#2f2d6a",
    strokeWidth: 1
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 36.9,
    textAnchor: "middle",
    fontSize: 15,
    fill: "#b9b6f0"
  }, "\u2650&#xFE0E;")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 167.9,
    y: 84.2,
    textAnchor: "middle",
    fontSize: 11,
    fontFamily: "Roboto, sans-serif",
    fill: "#6f6cb0"
  }, "9")), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 48,
    x2: 200,
    y2: 4,
    stroke: "#4a4699",
    strokeWidth: 1.5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 104,
    x2: 200,
    y2: 48,
    stroke: "#2f2d6a",
    strokeWidth: 1
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 36.9,
    textAnchor: "middle",
    fontSize: 15,
    fill: "#b9b6f0"
  }, "\u2651&#xFE0E;")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 232.1,
    y: 84.2,
    textAnchor: "middle",
    fontSize: 11,
    fontFamily: "Roboto, sans-serif",
    fill: "#6f6cb0"
  }, "10")), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 276,
    y1: 68.4,
    x2: 298,
    y2: 30.3,
    stroke: "#4a4699",
    strokeWidth: 1.5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 248,
    y1: 116.9,
    x2: 276,
    y2: 68.4,
    stroke: "#2f2d6a",
    strokeWidth: 1
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 323,
    y: 82,
    textAnchor: "middle",
    fontSize: 15,
    fill: "#b9b6f0"
  }, "\u2652&#xFE0E;")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 287.7,
    y: 116.3,
    textAnchor: "middle",
    fontSize: 11,
    fontFamily: "Roboto, sans-serif",
    fill: "#6f6cb0"
  }, "11")), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 331.6,
    y1: 124,
    x2: 369.7,
    y2: 102,
    stroke: "#4a4699",
    strokeWidth: 1.5
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 283.1,
    y1: 152,
    x2: 331.6,
    y2: 124,
    stroke: "#2f2d6a",
    strokeWidth: 1
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 368.1,
    y: 160,
    textAnchor: "middle",
    fontSize: 15,
    fill: "#b9b6f0"
  }, "\u2653&#xFE0E;")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 319.8,
    y: 171.9,
    textAnchor: "middle",
    fontSize: 11,
    fontFamily: "Roboto, sans-serif",
    fill: "#6f6cb0"
  }, "12")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 312.8,
    cy: 241,
    r: 9,
    fill: "url(#m)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 235,
    cy: 260.6,
    r: 7,
    fill: "#c9885a"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.4,
    cy: 283.6,
    r: 8,
    fill: "#d8b98a"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.6,
    cy: 179.5,
    r: 6,
    fill: "#8ab6d8"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.9,
    cy: 91.7,
    r: 10,
    fill: "#9a7a5a"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.5,
    cy: 151.8,
    r: 7,
    fill: "#e0c07a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthWheel);
export default __webpack_public_path__ + "static/media/birth-wheel.c86b941c84f79a4066ac45153d008114.svg";
export { ForwardRef as ReactComponent };